import { CryptoError } from "./errors.js";
const TEXT_ENCODER = new TextEncoder();
const TEXT_DECODER = new TextDecoder();
export function utf8ToBytes(input) {
    return TEXT_ENCODER.encode(input);
}
export function bytesToUtf8(input) {
    return TEXT_DECODER.decode(input);
}
export function generateSalt(length = 16) {
    if (!Number.isInteger(length) || length < 16 || length > 64) {
        throw new CryptoError("invalid-input", "Salt length must be an integer between 16 and 64.");
    }
    const out = new Uint8Array(length);
    crypto.getRandomValues(out);
    return out;
}
export function generateNonce() {
    const out = new Uint8Array(24);
    crypto.getRandomValues(out);
    return out;
}
export function concatBytes(first, second) {
    const out = new Uint8Array(first.length + second.length);
    out.set(first, 0);
    out.set(second, first.length);
    return out;
}
export function constantTimeEqual(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    let diff = 0;
    for (let i = 0; i < a.length; i += 1) {
        const x = a[i];
        const y = b[i];
        if (x === undefined || y === undefined) {
            return false;
        }
        diff |= x ^ y;
    }
    return diff === 0;
}
export function zeroBytes(target) {
    target.fill(0);
}
export function assertKeyLength(key, expected, label) {
    if (key.length !== expected) {
        throw new CryptoError("invalid-key-length", `${label} must be ${expected} bytes.`);
    }
}
//# sourceMappingURL=bytes.js.map